import { render } from "./CoBrandNeon.vue?vue&type=template&id=07c5928a&scoped=true"
import script from "./CoBrandNeon.vue?vue&type=script&lang=js"
export * from "./CoBrandNeon.vue?vue&type=script&lang=js"

import "./CoBrandNeon.vue?vue&type=style&index=0&id=07c5928a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c5928a"]])

export default __exports__